export default __webpack_public_path__ + "static/media/brand.ced89309.jpg";